//#region components/combobox_multi_select/combobox_multi_select_constants.js
var e = {
	EXTRA_SMALL: "xs",
	SMALL: "sm",
	DEFAULT: "md"
}, t = {
	100: "xs",
	200: "xs",
	300: "sm",
	xs: "xs",
	sm: "xs",
	md: "sm"
}, n = {
	100: 1.4,
	200: .4,
	300: .2,
	xs: 1.4,
	sm: .4,
	md: .2
}, r = {
	MULTI_SELECT_SIZES: e,
	CHIP_SIZES: t,
	CHIP_TOP_POSITION: n
};
//#endregion
export { t as CHIP_SIZES, n as CHIP_TOP_POSITION, e as MULTI_SELECT_SIZES, r as default };

//# sourceMappingURL=combobox-multi-select-constants.js.map